__turbopack_context__.v({
  "compact": "SlideInput-module-scss-module__2CMBia__compact",
  "container": "SlideInput-module-scss-module__2CMBia__container",
  "disabled": "SlideInput-module-scss-module__2CMBia__disabled",
  "error": "SlideInput-module-scss-module__2CMBia__error",
  "input-field": "SlideInput-module-scss-module__2CMBia__input-field",
  "input-wrapper": "SlideInput-module-scss-module__2CMBia__input-wrapper",
  "label": "SlideInput-module-scss-module__2CMBia__label",
  "range-wrapper": "SlideInput-module-scss-module__2CMBia__range-wrapper",
  "slide-input": "SlideInput-module-scss-module__2CMBia__slide-input",
  "sub-text": "SlideInput-module-scss-module__2CMBia__sub-text",
});
